import { IExcelContextMenu, IExcelMenu } from "../schema/MenuSchema";
import { ICellSpan, IExcelCellOption } from "../schema/ConfigSchema";
import { Column } from "vxe-table/types/column";
import "@/utils/extensions/libs/ArrayExtension";
import "@/utils/extensions/libs/NumberExtension";
import Arrays from "@/utils/extensions/Arrays";
import { OtherSexOption } from "@/components/excel/schema/selector/sex";
import { SingleSelector } from "@/components/excel/schema/label/mode";
import { SexOption } from "@/components/excel/schema/label/type/other";
// import { createExcelColumn } from "@/utils/excel/ColumnConfig";
const createExcelColumn = (cols: number) => {
  return Array.from(Array(cols)).map((_, idx) => {
    const result = (idx + 1).radix(27);
    // 末位不能是 0 如果是 0 自动升为 1   因为0在最后转字符串时没有意义
    return result
      .map((it: number, index: number) => {
        if (index === 0) {
          return String.fromCharCode((it || 1) + 64);
        }
        return String.fromCharCode(it + 65);
      })
      .join("");
  });
};
export const mergeMenu = (left?: IExcelMenu, right?: IExcelMenu) => {
  if (!right) {
    return left;
  }
  if (!left) {
    return right;
  }
  const options = Arrays.merge(left.options, right.options);
  return { options };
};
export const mergeContextMenu = (
  excelContextMenu?: IExcelContextMenu,
  propsMenu?: IExcelContextMenu
) => {
  if (!propsMenu) {
    return excelContextMenu;
  }
  if (!excelContextMenu) {
    return propsMenu;
  }
  const { body, header } = propsMenu;
  if (!body && !header) {
    return excelContextMenu;
  }
  const bodyMenu = mergeMenu(excelContextMenu.body, body);
  const headerMenu = mergeMenu(excelContextMenu.header, header);
  return { header: headerMenu, body: bodyMenu };
};
export interface ICell {
  span: ICellSpan;
  value: string;
}

export const convertRows = (
  columns: Array<Column>,
  rows: Array<Array<ICell>>
) => {
  return rows.map((row, rowIndex) => {
    const rowObj = {};
    columns.forEach((column, columnIndex) => {
      if (column.field) {
        const cell = row[columnIndex];
        Object.defineProperty(rowObj, column.field, { value: cell.value });
      }
    });
    return rowObj;
  });
};
export type moveType = "insert" | "delete";
export interface IColumnMoveCache {
  type: moveType;
  columnIndex: number;
  cells: IExcelCellOption[];
}
// version -> rowIndex -> columnIndex
export type ICellEditCache = Map<
  number,
  Map<number, Map<number, IExcelCellOption>>
>;
export const createCell = () => {
  return {
    span: { colSpan: 1, rowSpan: 1 },
    text: "",
  };
};
export const createColumnMoveCache = (columnIndex: number, rowSize: number) => {
  const cells = Array.from(Array(rowSize)).map(createCell);
  return { type: "insert", columnIndex, cells };
};
export const mergeRows = (
  rows: IExcelCellOption[][],
  moveCaches: IColumnMoveCache[],
  cellCache: ICellEditCache
) => {
  const tempRows = rows.map((it) => [...it]);
  moveCaches.forEach((moveCache, version) => {
    const versionCache = cellCache.get(version);
    tempRows.forEach((row, rowIndex) => {
      if (moveCache.type === "insert") {
        row.insert(moveCache.columnIndex, [moveCache.cells[rowIndex]]);
      } else if (moveCache.type === "delete") {
        tempRows.forEach((row) => {
          row.splice(moveCache.columnIndex, 1);
        });
      }
      if (versionCache) {
        const rowCache = versionCache.get(rowIndex);
        if (rowCache) {
          rowCache.forEach((cell, columnIndex) => {
            row[columnIndex] = cell;
          });
        }
      }
    });
  });
  return tempRows;
};
export const mockExcelRows = (
  rows: number,
  columns: number
): IExcelCellOption[][] => {
  const rowArray = Array.from(new Array(rows));
  const columnArray = Array.from(new Array(columns));
  return rowArray.map((_, rowIndex) => {
    return columnArray.map((_, columnIndex) => {
      const span = { colSpan: 1, rowSpan: 1 };
      const text = `${rowIndex + 1}-${columnIndex + 1}`;
      const editor = { type: SexOption.value, mode: SingleSelector.value };
      return { span, text, editor };
    });
  });
};
export const mockRows = (rows: number, columns: number) => {
  const rowArray = Array.from(new Array(rows));
  const columnArray = Array.from(new Array(columns));
  return rowArray.map((_, rowIndex) => {
    return columnArray.map((_, columnIndex) => {
      const span = { colSpan: 1, rowSpan: 1 };
      const value = `${rowIndex}-${columnIndex}`;
      return { span, value, valueType: 1, labelType: 1, editable: true };
    });
  });
};
export const createColumns = (
  mergedRows: IExcelCellOption[][],
  minCols: number
) => {
  // 还要考虑新插入的列
  const maxCols = mergedRows.max((row: IExcelCellOption[]) => {
    return row.sum((cell) => cell.span.colSpan || 1);
  });
  const cols = Math.max(maxCols - 1, minCols);
  const columns = createExcelColumn(cols).map((it, idx) => ({
    title: `${it}`,
    field: idx + 1,
    minWidth: "80px",
    headerAlign: "center",
    sortable: true,
    editRender: {
      name: "ElSelect",
    },
    filters: [{ data: "" }],
    filterRender: {
      name: "input",
    },
  }));
  return [{ type: "index" }, ...columns];
};
export const completeRows = (
  mergedRows: IExcelCellOption[][],
  columns: Column[]
) => {
  return mergedRows.map((row, rowIndex) => {
    const rowObj: { [key: string]: IExcelCellOption } = {};
    columns.forEach((column, columnIndex) => {
      if (column.field) {
        rowObj[column.field] = row[columnIndex] || createCell();
      }
    });
    return rowObj;
  });
};
